import ApiModel from './ApiModel'

class stories extends ApiModel {
}

export default new stories('/stories');